import React from 'react';
import {
  Amount_entered,
  Empty_field_with_placeholder, enter_between,
  getSubCategoryId,
  number_0_00, number_50_00,
} from '../../../utils/DictionaryManagementUtils';
import AmountMenuFP from '../FullPagesComponents/Services/Amount/AmountMenuFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

const EnterLoanAmountDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  amount,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const showConvert = amount.enable_additional_instruction;
  const { colors } = globJSON.configurations.theme;

  //= ====================================================================
  return (
    <SimulatorsViewerArrangement
      simPlatform={simPlatform}
    >
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_0_00}
        showConvert={showConvert && enter_between}
        amountColor={colors.secondary_font_color}
        strTitle={Empty_field_with_placeholder}
        slideshowRefs={slideshowRefs}
        isLoan
      />
      <AmountMenuFP
        amount={amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_50_00}
        showConvert={showConvert && enter_between}
        IconBackgroundColor={colors.primary_cta_color}
        strTitle={Amount_entered}
        slideshowRefs={slideshowRefs}
        isLoan
      />
    </SimulatorsViewerArrangement>
  );
};

export default EnterLoanAmountDF;
